import React, { FC } from 'react';

export const breadcrumbsArea = 'breadcrumbs';
export const thumbnailsArea = 'thumbnails';
export const mainImageArea = 'main-image';
export const productActionCardArea = 'product-action-card';
export const productTabsDivider = 'product-tabs-divider';
export const tabsArea = 'tabs';
export const productDescriptionArea = 'product-detailed-info';
export const helpfulInfoArea = 'helpful-info';
export const relatedProductsArea = 'related-products';

export const Layout: FC = ({ children }) => {
  return (
    <div className="pdp-layout">
      {children}
      <style jsx>{`
        .pdp-layout {
          width: 100%;
          
          display: grid;
          grid:
            '${mainImageArea}' auto
            '${productActionCardArea}' auto
            '${productDescriptionArea}' auto
            '${helpfulInfoArea}' auto
            '${relatedProductsArea}' auto
            / 100%;
          row-gap: 20px;
          grid-row-gap: 20px;
          padding: 20px;
        }

        @media (min-width: 1024px) {
          .pdp-layout {
            display: grid;
            
            grid:
              '${breadcrumbsArea} ${breadcrumbsArea} ${breadcrumbsArea}' 50px
              '${thumbnailsArea} ${mainImageArea} ${productActionCardArea}' 550px
              '${productTabsDivider} ${productTabsDivider} ${productTabsDivider}' 40px
              '${tabsArea} ${tabsArea} ${tabsArea}' 40px
              '${productDescriptionArea} ${productDescriptionArea} ${helpfulInfoArea}' auto
              '${relatedProductsArea} ${relatedProductsArea} ${relatedProductsArea}' auto
              / 150px 2fr 1.3fr;
            column-gap: 20px;
            row-gap: 0;
            grid-column-gap: 20px;
            grid-row-gap: 0;
            padding: 0;
          }
        }
               
        :global(.pdp-layout *) {
          font-size: 15px;
        }        
      `}</style>
    </div>
  );
};
